<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4 shadow-sm border-0">
          <!-- UPDATED: Added flex-column and responsive alignment classes -->
          <div class="card-header pb-0 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
            <h6 class="font-weight-bolder mb-0">Device Positions</h6>
            <!-- btn-primary is now dynamic because of Navbar.vue - UPDATED: Added responsive width classes -->
            <button class="btn btn-sm btn-primary px-4 mb-0 w-100 w-md-auto" @click="handleAction()">
              <i class="fas fa-plus me-2"></i>Add New Position
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                  
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-4">Position Name</th>
                    <th class="text-secondary opacity-7">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="pos in positions" :key="pos.id">
                   
                    <td class="ps-4"><p class="text-xs font-weight-bold mb-0 text-dark">{{ pos.name }}</p></td>
                    <td>
                      <!-- UPDATED: Wrapped actions in a d-flex container for better mobile alignment -->
                      <div class="d-flex flex-wrap gap-1">
                        <!-- CHANGED text-info TO text-primary TO MATCH THEME -->
                        <button class="btn btn-link text-primary text-gradient px-3 mb-0" @click="handleAction(pos)">
                          <i class="fas fa-pencil-alt me-2"></i>Edit
                        </button>
                        <button class="btn btn-link text-danger text-gradient px-3 mb-0" @click="deletePos(pos.id)">
                          <i class="far fa-trash-alt me-2"></i>Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return { 
      positions: [],
      apiBaseUrl: process.env.VUE_APP_API_BASE_URL 
    };
  },
  methods: {
    // 1. HELPER: Get the current dynamic theme color
    getThemeColor() {
      return localStorage.getItem('themeColor') || '#5e72e4';
    },

    getAuthHeader() {
      const token = localStorage.getItem("token");
      return { headers: { Authorization: `Bearer ${token}` } };
    },

    async fetchPositions() {
      try {
        const res = await axios.get(`${this.apiBaseUrl}/v1/admin/device-position`, this.getAuthHeader());
        this.positions = res.data.data;
      } catch (error) {
        console.error("Error fetching positions:", error);
      }
    },

    async handleAction(item = null) {
      const themeColor = this.getThemeColor(); // Get the color

      const { value: name } = await Swal.fire({
        title: item ? 'Edit Position Name' : 'Add New Position',
        input: 'text',
        inputValue: item ? item.name : '',
        showCancelButton: true,
        confirmButtonColor: themeColor, // APPLY THEME COLOR HERE
        inputValidator: (value) => {
          if (!value) return 'You need to write something!'
        }
      });

      if (name) {
        try {
          const url = item 
            ? `${this.apiBaseUrl}/v1/admin/device-position/update/${item.id}` 
            : `${this.apiBaseUrl}/v1/admin/device-position/add`;
          
          await axios[item ? 'put' : 'post'](url, { name }, this.getAuthHeader());
          this.fetchPositions();
          
          // Apply theme color to success popup too
          Swal.fire({ title: 'Success', icon: 'success', confirmButtonColor: themeColor });
        } catch (error) {
          Swal.fire({ title: 'Error', icon: 'error', confirmButtonColor: themeColor });
        }
      }
    },

    async deletePos(id) {
      const themeColor = this.getThemeColor();

      const result = await Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#d33', // Keep delete red
        cancelButtonColor: '#6c757d'
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`${this.apiBaseUrl}/v1/admin/device-position/delete/${id}`, this.getAuthHeader());
          this.fetchPositions();
          Swal.fire({ title: 'Deleted!', icon: 'success', confirmButtonColor: themeColor });
        } catch (error) {
          Swal.fire({ title: 'Error', icon: 'error', confirmButtonColor: themeColor });
        }
      }
    }
  },
  mounted() {
    this.fetchPositions();
  }
};
</script>

<style scoped>
/* --- ADDED MOBILE RESPONSIVE CSS --- */
@media (max-width: 768px) {
  .card-header {
    padding-bottom: 20px !important;
  }
  .btn-sm {
    font-size: 11px;
    padding: 10px 15px;
  }
  .table thead th {
    padding-left: 1.5rem !important;
  }
}
</style>